import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useSelector, useDispatch } from "react-redux";

import {
  Dialog,
  DialogContent,
  DialogActions,
  Grid,
  Typography,
  TextField,
  Button,
  FormControlLabel,
  Checkbox,
  Autocomplete,
} from "@mui/material";

import useFetchData from "src/views/utilities/useFetchData";
import Loadable from "src/layouts/full/shared/loadable/Loadable";
import Loader from "src/components/Loader";
import { postData } from "src/views/utilities/api";
import { UPDATE_QUOTATION_HEAD } from "../slice/QuotationData";
import { useQueryClient } from "react-query";
import { RESET_QUOTATION_TABLE } from "../slice/QuotationTable";
import dayjs from "dayjs";

const initialSate = {
  netAmount: 0,
  cashAmount: 0,
  cashReceived: 0,
  bankAmount: 0,
  narration: "",
  party: null,
};
const Receipt = ({ open, handleClose, billSave }) => {
  const { data, isLoading, error } = useFetchData(
    ["bankList"],
    ["/api/getBankList"]
  );

  const dispatch = useDispatch();
  const billHead = useSelector((state) => state.quotationMaster);
  console.log(billHead,"billHeadbillHeadbillHead");
  
  const queryClient = useQueryClient();
  // Payment Details state (using a single state object)
  const [paymentDetails, setPaymentDetails] = useState(initialSate);
  // const [isCashReceivedTouched, setIsCashReceivedTouched] = useState(false);
  const [loading, setLoading] = useState(false);
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState("Cash");
  const [isSplit, setIsSplit] = useState(false);
  const [bank, setBank] = useState(null);
  const [balance, setBalance] = useState(0);

  useEffect(() => {
    
    setPaymentDetails((prev) => ({
      ...prev,
      netAmount: billHead.netTotal,
      party: billHead.party,
      cashReceived: billHead.receiptAmt,
    }));
    setBalance(billHead.netTotal-billHead.receiptAmt);
    
    setSelectedPaymentMethod(billHead.receiptType||"Cash");
    setBank(billHead.bankName);
    
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [billHead.netTotal, billHead.balance, billHead.receiptType]);

  if (isLoading) return <Loadable />;
  if (error)
    return (
      <>
        <Loadable />
        <p>Error: {error.message}</p>
      </>
    );

  // Handle button click to set the selected payment method
  const handlePaymentMethodClick = (method) => {
    setSelectedPaymentMethod(method);
    if (method === "Cash") {
      setIsSplit(false);
      setPaymentDetails({
        ...paymentDetails,
        bankAmount: 0,
        cashAmount: 0,
      });
      setBank(null);
    } else {
      setBank(data.bankList.data[0]);
      setPaymentDetails({
        ...paymentDetails,
        bankAmount: paymentDetails.cashReceived,
      });
    }
  };

  // Handle input changes for text fields
  const handleTextFieldChange = (e, field) => {
    const { value, type } = e.target;
    setPaymentDetails((prev) => ({
      ...prev,
      [field]: type === "number" ? Number(value) : value,
    }));
  };

  const handleCashRec = (e) => {
    const { value } = e.target;
    setPaymentDetails((prev) => ({
      ...prev,
      cashReceived: Number(value),
      bankAmount: selectedPaymentMethod !== "Cash" ? Number(value) : 0,
    }));
    // setIsCashReceivedTouched(true); // <-- Mark field as touched
    setBalance(paymentDetails?.netAmount - parseFloat(value));
    dispatch(
      UPDATE_QUOTATION_HEAD({
        receiptAmt: Number(value),
      })
    );
  };
  const resetPaymentDetails = () => {
    setPaymentDetails((prev) => ({
      ...prev,
      cashReceived: 0,
      bankAmount: 0,
    }));
    // setIsCashReceivedTouched(false);
    setBalance(0);
  };

  const handleSplit = (e) => {
    setIsSplit(e.target.checked);

    setPaymentDetails({
      ...paymentDetails,
      bankAmount: paymentDetails?.cashReceived,
      cashAmount: 0,
    });
  };

  const handleBankAmt = (e) => {
    const { value } = e.target;
    const cashAmt = paymentDetails.cashReceived - Number(value);
    setPaymentDetails({
      ...paymentDetails,
      bankAmount: Number(value),
      cashAmount: cashAmt,
    });
  };
  const handleCashAmt = (e) => {
    const { value } = e.target;
    const bankAmt = paymentDetails.cashReceived - Number(value);
    setPaymentDetails({
      ...paymentDetails,
      cashAmount: Number(value),
      bankAmount: bankAmt,
    });
  };

  const handleSubmit = async () => {
    const data = {
      ...paymentDetails,
      BillNo: billHead.billNo,
      bankname: bank?.label || null,
      receiptType: selectedPaymentMethod,
      date:dayjs().format(),
      branch:billHead.branch?.label || null,
      Type:"quotation"
    };
  
    try {
      const submitReceipt = await postData("/api/addRecieptToCollection", data);     
      billSave();
      if (submitReceipt.success) {
        dispatch(UPDATE_QUOTATION_HEAD({ receiptAmt: 0 })); // <- Reset stale(old data) receiptAmt
        handleClose();
        resetPaymentDetails();
        setSelectedPaymentMethod(billHead.receiptType); // <- Fix here
        dispatch(RESET_QUOTATION_TABLE());
        queryClient.invalidateQueries("masterData");
      }
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };
  
  const handleModalClose = () => {
    // setIsCashReceivedTouched(false); // Reset touched state on modal close
    // resetPaymentDetails(); // reset on modal close
    handleClose(); // closing modal
  };

  return (
    <>
      <Loader start={loading} />
      <Dialog open={open} onClose={handleModalClose} fullWidth maxWidth="sm">
        <DialogContent>
          <Grid container spacing={2}>
            {/* Payment Method Buttons */}
            <Grid item xs={6} sm={3}>
              <Button
                variant="contained"
                fullWidth
                color={selectedPaymentMethod === "Cash" ? "success" : "info"}
                onClick={() => handlePaymentMethodClick("Cash")}
              >
                Cash
              </Button>
            </Grid>
            <Grid item xs={6} sm={3}>
              <Button
                variant="contained"
                fullWidth
                color={selectedPaymentMethod === "Card" ? "success" : "info"}
                onClick={() => handlePaymentMethodClick("Card")}
              >
                Card
              </Button>
            </Grid>
            <Grid item xs={6} sm={3}>
              <Button
                variant="contained"
                fullWidth
                color={selectedPaymentMethod === "UPI" ? "success" : "info"}
                onClick={() => handlePaymentMethodClick("UPI")}
              >
                UPI
              </Button>
            </Grid>
            <Grid item xs={6} sm={3}>
              <Button
                variant="contained"
                fullWidth
                color={selectedPaymentMethod === "Bank" ? "success" : "info"}
                onClick={() => handlePaymentMethodClick("Bank")}
              >
                Bank
              </Button>
            </Grid>

            {/* Split Checkbox */}
            <Grid item xs={12}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={isSplit}
                    //   onChange={(e) => setIsSplit(e.target.checked)}
                    onChange={handleSplit}
                    disabled={selectedPaymentMethod === "Cash"} // Disable when "Cash" is selected
                  />
                }
                label="Split"
              />
            </Grid>

            {/* Bank Autocomplete */}

            <Grid item xs={12}>
              <Autocomplete
                value={bank}
                disabled={selectedPaymentMethod === "Cash"}
                onChange={(e, newValue) => setBank(newValue) 
                  // && setIsCashReceivedTouched(true)
                }
                options={data.bankList.data} // Assuming `banks` is a list of bank names or objects from the Redux store
                // getOptionLabel={(option) => option.name || option} // Assuming bank object has a `name` field, adjust as necessary
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Bank"
                    fullWidth
                    variant="outlined"
                  />
                )}
              />
            </Grid>

            {/* Net Amount */}
            <Grid item xs={12}>
              <TextField
                type="number"
                label="Net Amount"
                fullWidth
                variant="outlined"
                value={paymentDetails.netAmount}
                onChange={(e) => handleTextFieldChange(e, "netAmount")}
              />
            </Grid>

            {/* Narration */}
            <Grid item xs={12}>
              <TextField
                label="Narration"
                fullWidth
                variant="outlined"
                value={paymentDetails.narration}
                onChange={(e) => handleTextFieldChange(e, "narration")}
              />
            </Grid>

            {/* Cash Received */}
            <Grid item xs={12}>
              <TextField
                type="number"
                label="Cash Received"
                fullWidth
                variant="outlined"
                value={paymentDetails.cashReceived || ""}
                onChange={handleCashRec}
              />
            </Grid>

            {/* Bank Amount */}
            {selectedPaymentMethod !== "Cash" && (
              <Grid item xs={isSplit ? 6 : 12}>
                <TextField
                  type="number"
                  label="Bank Amount"
                  fullWidth
                  variant="outlined"
                  value={paymentDetails.bankAmount}
                  onChange={handleBankAmt}
                />
              </Grid>
            )}

            {/* Cash Amount (only if Split is enabled) */}
            {isSplit && (
              <Grid item xs={isSplit ? 6 : 12}>
                <TextField
                  type="number"
                  label="Cash Amount"
                  fullWidth
                  variant="outlined"
                  value={paymentDetails.cashAmount}
                  onChange={handleCashAmt}
                />
              </Grid>
            )}

            {/* Balance */}
            <Grid item xs={12}>
              <Typography variant="body2">Balance: {balance}</Typography>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleModalClose} color="error">
            Cancel
          </Button>
          <Button
            // disabled={!isCashReceivedTouched}
            disabled={!paymentDetails.cashReceived}
            variant="contained"
            color="primary"
            onClick={handleSubmit}
          >
            Submit
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

// PropTypes for type-checking
Receipt.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  billSave: PropTypes.func.isRequired,
};

export default Receipt;
